













import Vue from 'vue';

export default Vue.extend({
  name: 'Confirmation',
  props: {
    action: Function,
    button: String,
    whiteButton: {
      type: [String, Boolean],
      default: 'Cancel',
    },
    content: String,
    id: String,
    negative: Boolean,
  },
  methods: {
    exit() {
      this.$emit('exit');
    },
  },
});
